import React, { memo, useState, useEffect } from 'react';
import { MainApp } from './components';
import { ENV } from './config';
import { ScriptTagProvider } from './context/ScriptTagContext';
import { PreviewProvider } from './context/PreviewQueryContext';
import { LoggerProvider } from './context/LoggerContext';
import { Logger } from './components/Logger';
import { getCurrentScript } from './lib/DOM/Script';

function App({
	currentScript,
}: {
	currentScript?: HTMLElement | null | SVGScriptElement;
}) {
	const [currentScriptNode, setCurrentScriptNode] = useState<
		HTMLElement | null | SVGScriptElement
	>(null);

	useEffect(() => {
		const script = currentScript || getCurrentScript();
		setCurrentScriptNode(script);
	}, [currentScript]);

	if (!currentScriptNode) {
		return null;
	}

	return (
		<ScriptTagProvider currentScript={currentScriptNode}>
			<PreviewProvider>
				<LoggerProvider>
					<>
						<Logger domNode={currentScriptNode} />
						<MainApp environment={ENV} />
					</>
				</LoggerProvider>
			</PreviewProvider>
		</ScriptTagProvider>
	);
}

export default memo(App);
